import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { ManagementECSalesSearch } from "@/components/features/management/EC-sales";

import { useConfirmParams } from "./hooks";

export const ManagementECSalecTopPage = () => {
	const result = useConfirmParams();

	const { canRender } = result;
	if (!canRender) return <></>;

	const { hotelID } = result;

	return (
		<PageMeta title="ECの販売管理" url={generatePath(PATHS.HOTEL.MANAGEMENT.EC_SALES.TOP, { hotelID })}>
			<ManagementECSalesSearch hotelID={hotelID} />
		</PageMeta>
	);
};

ManagementECSalecTopPage.displayName = "ManagementECSalecTopPage";
